import React from 'react'
export const useDragScroll = (): ((nodeEle: HTMLElement | null) => void)[] => {
    const [node, setNode] = React.useState<HTMLElement>()

    const ref = React.useCallback((nodeEle) => {
        setNode(nodeEle)
    }, [])

    const handleMouseDown = React.useCallback(
        (e: Event | React.MouseEvent) => {
            if (!node) {
                return
            }
            const startPos = {
                left: node.scrollLeft,
                x: (e as React.MouseEvent).clientX
            }

            const handleMouseMove = (e: Event | React.MouseEvent) => {
                const dx = (e as React.MouseEvent).clientX - startPos.x
                node.scrollLeft = startPos.left - dx
            }

            const handleMouseUp = () => {
                document.removeEventListener('mousemove', handleMouseMove)
                document.removeEventListener('mouseup', handleMouseUp)
            }

            document.addEventListener('mousemove', handleMouseMove)
            document.addEventListener('mouseup', handleMouseUp)
        },
        [node]
    )

    const handleTouchStart = React.useCallback(
        (e: Event | React.TouchEvent) => {
            if (!node) {
                return
            }
            const touch = (e as React.TouchEvent).touches[0]
            const startPos = {
                left: node.scrollLeft,
                x: touch.clientX
            }

            const handleTouchMove = (e: Event | React.TouchEvent) => {
                const touch = (e as React.TouchEvent).touches[0]
                const dx = touch.clientX - startPos.x
                node.scrollLeft = startPos.left - dx
            }

            const handleTouchEnd = () => {
                document.removeEventListener('touchmove', handleTouchMove)
                document.removeEventListener('touchend', handleTouchEnd)
            }

            document.addEventListener('touchmove', handleTouchMove)
            document.addEventListener('touchend', handleTouchEnd)
        },
        [node]
    )

    React.useEffect(() => {
        if (!node) {
            return
        }
        node.addEventListener('mousedown', handleMouseDown)
        node.addEventListener('touchstart', handleTouchStart)
        return () => {
            node.removeEventListener('mousedown', handleMouseDown)
            node.removeEventListener('touchstart', handleTouchStart)
        }
    }, [node])

    return [ref]
}
